import { pb } from './pb';

// Public: fetch published slides ordered
export async function fetchHomeSlidesPublic(){
  const res = await pb.collection('home_slides').getFullList({
    filter: 'published=true',
    sort: 'order,created',
  });
  return res;
}

// Admin list with pagination and search
export async function fetchHomeSlidesAdmin(page = 1, perPage = 30, search = ''){
  const filters = [];
  if(search){
    const s = search.replace(/"/g, '\\"');
    filters.push(`title ~ "%${s}%" || subtitle ~ "%${s}%"`);
  }
  const filter = filters.join(' && ');
  return pb.collection('home_slides').getList(page, perPage, {
    filter,
    sort: 'order,created',
  });
}

export async function createHomeSlide(data){
  return pb.collection('home_slides').create(data);
}

export async function updateHomeSlide(id, data){
  return pb.collection('home_slides').update(id, data);
}

export async function deleteHomeSlide(id){
  return pb.collection('home_slides').delete(id);
}
